// Local authentication service for development

export interface LocalUser {
  email: string;
  name: string;
  password: string;
}

// Local users database
const LOCAL_USERS: LocalUser[] = [
  {
    email: 'Peter.Finnemore@lakelanddairies.com',
    name: 'Peter Finnemore',
    password: 'LakelandWorker1!'
  },
  {
    email: 'Donal.Crotty@lakelanddairies.com',
    name: 'Donal Crotty',
    password: 'LakelandWorker1!'
  },
  {
    email: 'Aman.Jakhar@xendl.com',
    name: 'Aman Jakhar',
    password: 'LakelandWorker1!'
  },
  {
    email: 'Robin.Roy@xendl.com',
    name: 'Robin Roy',
    password: 'LakelandWorker1!'
  },
  {
    email: 'Dschroeder@xendl.com',
    name: 'David Schroeder',
    password: 'LakelandWorker1!'
  }
];

class LocalAuthService {
  private readonly STORAGE_KEY = 'nyx_auth_user';

  /**
   * Login with email and password
   */
  login(email: string, password: string): boolean {
    const user = LOCAL_USERS.find(
      u => u.email.toLowerCase() === email.toLowerCase() && u.password === password
    );

    if (user) {
      // Store user in sessionStorage
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify({
        email: user.email,
        name: user.name
      }));
      return true;
    }

    return false;
  }

  /**
   * Logout
   */
  logout(): void {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  /**
   * Check if user is authenticated
   */
  isAuthenticated(): boolean {
    return this.getCurrentUser() !== null;
  }

  /**
   * Get current authenticated user
   */
  getCurrentUser(): { email: string; name: string } | null {
    const stored = sessionStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch {
        return null;
      }
    }
    return null;
  }

  /**
   * Get user's display name
   */
  getUserDisplayName(): string {
    const user = this.getCurrentUser();
    return user?.name || 'User';
  }

  /**
   * Get user's email
   */
  getUserEmail(): string | null {
    const user = this.getCurrentUser();
    return user?.email || null;
  }
}

export const localAuthService = new LocalAuthService();
export default localAuthService;
